module.exports = __webpack_public_path__ + "img/Icon awesome-calendar-alt.01a66d16.svg";